// @flow

import * as React from 'react';

// import AdsumClock from '@adactive/arc-clock';

import marinaSquareLogo from '../../assets/marinaSquareLogo.png';

import './header.css';
import '../adsum-clock/adsumClock.css';

// type ClockUIPropsType = {|
//     timeStr: string,
//     dateStr: string,
// |};

// const ClockUi = ({ timeStr, dateStr }: ClockUIPropsType) => (
//     <div role="presentation" className="adsum-clock-wrapper">
//         <div className="adsum-clock">
//             <div className="day-date">{dateStr}</div>
//             <div className="time">{timeStr}</div>
//         </div>
//     </div>
// );

// const Clock = AdsumClock(ClockUi);

const Header = () => (
    <div className="app-header">
        <img src={marinaSquareLogo} className="marina-square-logo" alt="marina-square-logo" />
        {/* <Clock lang="en" timeFormat="24hrs" /> */}
    </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js